"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROW_HEIGHT = exports.DEFAULT_AUTOSIZE_PADDING = exports.DEFAULT_TOTAL_FONT = exports.DEFAULT_SUBTOTAL_FONT = exports.DEFAULT_ROW_FONT = exports.DEFAULT_HEADER_FONT = exports.ROW_SUBTOTAL_CLASS = exports.ROW_TOTAL_CLASS = exports.HEADER_LABEL_CLASS = exports.VALUE_CLASS = exports.COLS_PER_PAGE = exports.AVAILABLE_TOTALS = exports.COLUMN_GROUPING_DELIMITER = exports.ROW_SUBTOTAL = exports.ROW_TOTAL = exports.MEASURE_COLUMN = exports.COLUMN_ATTRIBUTE_COLUMN = exports.ROW_ATTRIBUTE_COLUMN = void 0;
exports.ROW_ATTRIBUTE_COLUMN = "ROW_ATTRIBUTE_COLUMN";
exports.COLUMN_ATTRIBUTE_COLUMN = "COLUMN_ATTRIBUTE_COLUMN";
exports.MEASURE_COLUMN = "MEASURE_COLUMN";
exports.ROW_TOTAL = "rowTotal";
exports.ROW_SUBTOTAL = "rowSubtotal";
exports.COLUMN_GROUPING_DELIMITER = " › ";
exports.AVAILABLE_TOTALS = ["sum", "max", "min", "avg", "med", "nat"];
exports.COLS_PER_PAGE = 1000;
exports.VALUE_CLASS = "s-value";
exports.HEADER_LABEL_CLASS = "s-header-cell-label";
exports.ROW_TOTAL_CLASS = "gd-row-total";
exports.ROW_SUBTOTAL_CLASS = "gd-table-row-subtotal";
exports.DEFAULT_HEADER_FONT = '12px / 28px gdcustomfont, avenir, "Helvetica Neue", arial, sans-serif';
exports.DEFAULT_ROW_FONT = '12px / 26px gdcustomfont, avenir, "Helvetica Neue", arial, sans-serif';
exports.DEFAULT_SUBTOTAL_FONT = '700 12px / 26px gdcustomfont, avenir, "Helvetica Neue", arial, sans-serif';
exports.DEFAULT_TOTAL_FONT = '700 12px / 26px gdcustomfont, avenir, "Helvetica Neue", arial, sans-serif';
/**
 * DEFAULT_AUTOSIZE_PADDING needs to match real padding from styles
 */
exports.DEFAULT_AUTOSIZE_PADDING = 12;
exports.DEFAULT_ROW_HEIGHT = 28;
//# sourceMappingURL=constants.js.map